module.exports = __webpack_public_path__ + "static/media/star.63647daf.svg";